import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Star } from 'lucide-react';

const googleReviews = [
  {
    id: '1',
    author_name: 'Marie & Pierre L.',
    rating: 5,
    content: "Une experience magique ! Nicolas et Maud sont des hotes exceptionnels. La cuisine etait delicieuse, les paysages a couper le souffle. Le catamaran etait spacieux, tres confortable, et parfaitement entretenu. On recommande a 1000% !",
    cruise_name: 'Tour de Corse',
    relative_time: 'il y a 3 mois',
  },
  {
    id: '2',
    author_name: 'Famille Durand',
    rating: 5,
    content: "Nos enfants en parlent encore ! Une semaine parfaite entre baignades dans des criques secretes, decouvertes culinaires et bonne humeur. L'équipage connait les meilleurs spots. Merci pour ces souvenirs inoubliables.",
    cruise_name: 'Corse du Sud',
    relative_time: 'il y a 2 mois',
  },
  {
    id: '3',
    author_name: 'Sophie & Thomas B.',
    rating: 5,
    content: "Scandola depuis la mer, c'est juste extraordinaire. L'équipage connait tous les mouillages secrets. La pension complète est d'une qualité remarquable avec des produits locaux. Une vraie experience slow tourisme.",
    cruise_name: 'Ouest Corse',
    relative_time: 'il y a 1 mois',
  },
];

const GoogleIcon = () => (
  <svg className="h-5 w-5" viewBox="0 0 24 24">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

const ReviewCard = ({ review }) => (
  <Card className="bg-white border border-slate-100 shadow-md h-full hover:shadow-lg transition-shadow" data-testid={`review-card-${review.id}`}>
    <CardContent className="p-8">
      {/* Google header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex gap-1">
          {[...Array(review.rating)].map((_, i) => (
            <Star key={i} className="h-4 w-4 fill-[#FBBC05] text-[#FBBC05]" />
          ))}
        </div>
        <GoogleIcon />
      </div>
      
      <p className="text-[#4A5568] leading-relaxed mb-6 text-sm">
        "{review.content}"
      </p>
      
      <div className="border-t border-slate-100 pt-4 flex items-center justify-between">
        <div>
          <p className="font-semibold text-[#0A2540] text-sm">{review.author_name}</p>
          <p className="text-xs text-[#94A3B8]">{review.cruise_name} - {review.relative_time}</p>
        </div>
        <div className="flex items-center gap-1 bg-[#F8F9FA] px-2 py-1 rounded">
          <Star className="h-3 w-3 fill-[#FBBC05] text-[#FBBC05]" />
          <span className="text-xs font-bold text-[#0A2540]">5.0</span>
        </div>
      </div>
    </CardContent>
  </Card>
);

const TestimonialsSection = () => {
  return (
    <section className="py-24 bg-[#0A2540]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-[#2A9D8F] font-medium text-sm uppercase tracking-wider">
            Avis Google
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-4 mb-6">
            Ils ont vecu <span className="italic text-[#2A9D8F]">l'experience</span>
          </h2>
          <div className="flex items-center justify-center gap-3 mt-4">
            <div className="flex gap-0.5">
              {[1,2,3,4,5].map(i => (
                <Star key={i} className="h-5 w-5 fill-[#FBBC05] text-[#FBBC05]" />
              ))}
            </div>
            <span className="text-white font-bold text-lg">5.0</span>
            <span className="text-white/60 text-sm">sur Google</span>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {googleReviews.map((review) => (
            <ReviewCard key={review.id} review={review} />
          ))}
        </div>

        {/* Google Reviews Badge */}
        <div className="mt-12 text-center">
          <a
            href="https://www.google.com/search?q=SOGNUDIMARE+Avis"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-6 py-3 bg-white/10 rounded-lg hover:bg-white/20 transition-colors"
            data-testid="google-reviews-link"
          >
            <GoogleIcon />
            <div className="text-left">
              <div className="text-white font-semibold text-sm">Voir tous les avis sur Google</div>
              <div className="text-white/60 text-xs">Note moyenne : 5.0/5</div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
